import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostEdc_import = z.any()
export type TagsPostEdc_import = z.infer<typeof tagsPostEdc_import>

export const consumesPostEdc_import = z.any()
export type ConsumesPostEdc_import = z.infer<typeof consumesPostEdc_import>

export const bodyPostEdc_import = z.object({ "attachment": z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string().optional(), "file": z.any(), "type": z.string().optional() }), "buildingId": z.union([z.string(), z.object({ "value": z.string() })]).optional() })
export type BodyPostEdc_import = z.infer<typeof bodyPostEdc_import>

export const responsePostEdc_import = z.object({ "payload": z.object({ "count": z.number(), "matchedEans": z.array(z.string()), "unmatchedEans": z.array(z.string()), "ambiguousEans": z.array(z.string()), "importedByCollectionPoint": z.array(z.object({ "collectionPointId": z.string(), "name": z.string(), "ean": z.string(), "count": z.number() })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostEdc_import = z.infer<typeof responsePostEdc_import>

interface IPostEdc_import extends BaseMethodType {
  tags: TagsPostEdc_import,
  consumes: ConsumesPostEdc_import,
  body: BodyPostEdc_import,
  response: ResponsePostEdc_import
}
export const URL = '/edc-import'
export const validation = {
  post: {
    tags: tagsPostEdc_import,
    consumes: consumesPostEdc_import,
    body: bodyPostEdc_import,
    response: responsePostEdc_import
  }
}
export interface Edc_import extends BaseRouteType {
  post: IPostEdc_import
}